import { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link} from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import { getOpenOrders, getOrderInstance, deleteOrderInstance, updateOrder } from '../api/commerce';
import { useParams } from "react-router-dom";
import { Info } from 'lucide-react';
import { SidebarProvider } from "../components/SidebarContext";
import InfoMark from '../components/InfoMark';
import ContactFormModal from '../components/ContactFormModal';
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import SidebarToggle from '../components/SidebarToggle';
import Sidebar from '../components/Sidebar';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import "../css/OrderMgmt.css";

const OrderReview = () => {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);
  const [consoleError, setConsoleError] = useState("");
  const [profile, setProf] = useState("");
  const [itemSeller, setItemSeller] = useState("");
  const [itemId, setItemId] = useState("");
  const [updatedProfile, setUpdatedProf] = useState("");
  const [OrderId, setOrderID] = useState();
  const [orderDeliveryId, setOrderDeliveryId] = useState();
  const [isInfoModal, setInfoModal] = useState(false);
  const [InfoP, setInfoP] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isContModalOpen, setIsContModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("open"); 
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const { user, isAuthenticated, loading} = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      }
    }
  }, [user, isAuthenticated, loading, navigate, location]);
  
  useEffect(() => {
    fetch("/data/InfoNote.json")
      .then((res) => res.json())
      .then((data) => setInfoP(data.OrderManagement))
      .catch((err) => setConsoleError("Error loading content:", err));
  }, []);

  const fetchOrderInfo = async (OrderId) => {
    try {
      const res = await getOrderInstance(OrderId);
      setProf(res.data.delivery);
      setUpdatedProf(res.data.delivery);
      setOrderDeliveryId(res.data.delivery.id);
    } catch (error) {
      setConsoleError("Error loading user information:", error);
    } 
  };
  
  const fetchOrders = async () => {
    try {
      const res = await getOpenOrders();
      setOrders(res.data.results);
    } catch (error) {
      setConsoleError("Error loading user information:", error);
    } 
  };

  useEffect(() => {
    fetchOrders();
  }, []);
  

  const handleCancelOrder = async (OrderId) => {
    if (!window.confirm(setlang==="en"?"Are you sure about canceling this order?":"آیا می خوای این سفارش رو لغو کنی")) return;
    try {
      await deleteOrderInstance(OrderId); 
      fetchOrders();
    } catch (error) {
      setConsoleError("Error deleting order:", error);
      alert(setlang==="en"?"Failed to delete order.":"مشکلی رخ داد، لطفا دوباره تلاش کن");
      setError(setlang==="en"?"Failed to delete order.":"مشکلی رخ داد، لطفا دوباره تلاش کن");
    }
  };

  const handleDeliveryUpdate = async () => {
    try {
      const UpdatePayload = {
        first_name:updatedProfile.first_name,
        last_name:updatedProfile.last_name,
        email:updatedProfile.email,
        contact: updatedProfile.phone,
        address: updatedProfile.address,
        city: updatedProfile.city,
        province: updatedProfile.province,
        zipcode: updatedProfile.zipcode,
        country: updatedProfile.country,
      };

      await updateOrder(orderDeliveryId, UpdatePayload);
      fetchOrders();

      // Reset states
      setError("");
      alert(setlang==="en"?"Delivery address updated successfully.":"آدرس پستی گیرنده با موفقیت به‌روزرسانی شد");

    } catch (err) {
      setError(setlang==="en"?"Failed to update delivery address. Review the information provided":"در به‌روزرسانی آدرس پستی مشکلی رخ داد، لطفا اطلاعات وارد شده رو اصلاح کن");
    }
  };

  // Update temporary modal form data
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedProf((prev) => ({ ...prev, [name]: value }));
  };

  // Submit: apply changes and close
  const handleSaveprofile = (e) => {
    e.preventDefault();
    setProf(updatedProfile);
    handleDeliveryUpdate(OrderId);
    closeModal();
  };

  // Cancel: discard changes and close
  const handleCancel = () => {
    setProf(profile); 
    closeModal();
  };
  
  // Utilities
  const openModal = (order) => {
    setOrderID(order);
    fetchOrderInfo(order)
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsContModalOpen(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  const handleContact = (seller, prod) => {
    setItemSeller(seller);
    setItemId(prod);
    setIsContModalOpen(true);
  };

  // Transation
  dayjs.extend(utc);
  dayjs.extend(jalaliday);
  const toPersiDigits = (str) =>
    str.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  
  if (loading) return <Loading />;  
  if (!isAuthenticated) return <p>{setlang==="en"?"You must be logged in to review orders.":"لطفا ابتدا وارد حساب کاربری شو"}</p>;
  
  return (
    <>
      <NavbarLog />
      <SidebarProvider>
      <SidebarToggle />
      <Info size={25} className={setlang==="en"?"InfoMark-en":"InfoMark-fa"} onMouseEnter={()=>setInfoModal(true)} onMouseLeave={()=>setInfoModal(false)}/>
      {isInfoModal && <InfoMark info={setlang==="en"?InfoP.en:InfoP.fa} setlang={setlang}/>}
      <div className={setlang==="en"?"order-page-en":"order-page-fa"}>
      
      {setlang==="en" && 
        <Sidebar />
      }

        {setlang === "en" ?
        <div className='order-list'>
          <h2>My Orders</h2>
          <div className="order-tabs-container">
            <Link to={`/${setlang}/review/open-orders`}>
              <button
                onClick={() => setActiveTab("open")}
                className={"active"}
                >
                {setlang === "en" ? "Open" : "در حال ارسال"}
              </button>
            </Link>
            <Link to={`/${setlang}/review/canceled-orders`}>
              <button
                onClick={() => setActiveTab("canceled")}
                >
                {setlang === "en" ? "Canceled" : "لغو شده"}
              </button>
            </Link>
            <Link to={`/${setlang}/review/closed-orders`}>
              <button
                onClick={() => setActiveTab("past")}
                >
                {setlang === "en" ? "Past" : "بسته شده"}
              </button>
            </Link>
          </div>
          {orders.length === 0 ? (
            <p style={{margin:"1rem"}} >No open orders yet</p>
          ) : (
            orders.map((order) => (
              <>
                <div key={order.id} className='item-list'>
                  <ul>
                    {order.items.map((item) => (
                      <li key={item.id}>
                        <div className="order-images">
                          {Array.isArray(item.product_images) && item.product_images.length > 0 &&
                            item.product_images.map((img) => (
                              <img
                                key={img.id}
                                src={img.image}
                                alt={item.product_name}
                                className="order-image"
                              />
                            ))
                          }
                          {/* Videos */}
                          {Array.isArray(item.product_videos) && item.product_videos.length > 0 &&
                            item.product_videos.map((vid) => (
                              <video
                                key={vid.id} 
                                src={vid.video}
                                controls
                                className="order-image"
                              />
                            ))
                          }
                        </div>
                        
                        <div className="arrival-note">
                          <div>
                            <p><strong>{item.product_name}</strong></p>
                            <p>Price: IRT {new Number(item.price).toLocaleString()}</p>
                            <p>Seller: {item.seller_username}</p>
                            <p>Shipped by: {item.shipping_style}</p>
                            <p>
                              <strong>Note:</strong> deliveries may take <span className="highlight">up to two weeks</span>.
                            </p>
                            {item.arrival_date === null ? null:
                            <span><strong>Arrives latest by: </strong>{dayjs.utc(item.arrival_date).calendar("jalali").locale("fa").format("YYYY/MM/DD")}</span>
                            }
                            </div>
                            <div className='cont-contact-button'>
                              <button onClick={()=>handleContact(item.seller, item.product)}>{setlang === "en" ? "Contact Seller" : "تماس با فروشنده" }</button>
                            </div>

                            {isContModalOpen && (
                            <div onClick={handleOverlayClick} className="modal-overlay" type='submit'> 
                              <div className="c-modal-container" onClick={e => e.stopPropagation()}>
                                <ContactFormModal receiverId={itemSeller} itemId={itemId} setlang={setlang}/>
                              </div>
                            </div>
                            )}
                        </div>
                      </li>
                    ))}
                  </ul>
                  <div className="order-sum">
                    <p>Total: IRT{new Number(order.total_amount).toLocaleString()}</p>
                    {order.order_status==="paid"? (
                      <p>Order Status: will be shipped soon</p>
                    ):(
                      <p>Order Status: {order.order_status}</p>
                    )}
                    <p>Order Number: {order.order_number}</p>
                    <p>Placed on: {dayjs.utc(order.created_at).calendar("jalali").locale("fa").format("YYYY/MM/DD")}</p>
                  </div>

                  <div className='delivery-info'>
                    <h3>Delivery information</h3>
                    <p>Tracking Number: {order.delivery.tracking_number}</p>
                    <p>Delivery Status: {order.delivery.status}</p>
                    <p>Receiver: {order.delivery.last_name}, {order.delivery.first_name} </p>
                    <p>E-mail: {order.delivery.email} Phone No.:{order.delivery.contact} </p>
                    <p>Address: {order.delivery.address} </p>
                    <p>{order.delivery.city}, {order.delivery.province}, {order.delivery.country} </p>
                    <p>Zipcode:{order.delivery.zipcode}</p>
                  </div>
                  <div className="order-actions">
                    <button className='btn-remove' onClick={() => handleCancelOrder(order.id)}>Cancel order</button>
                    <button className='btn' onClick={() => openModal(order.id)}>Update delivery information</button>
                  </div>
                </div>
              </>
            ))
          )}
          {isModalOpen && (
          <div onClick={handleOverlayClick} className="modal-overlay" type='submit'> 
            <div className="c-modal-container" onClick={e => e.stopPropagation()}>
              <h1>Delivery Information</h1>
              <p>Verify delivery information</p>
              <form>
                <div>
                  <label>First Name</label>
                  <input type="text" name="first_name" value={updatedProfile.first_name || ""} onChange={handleChange} placeholder="Enter first name" />
                </div>
                <div>
                  <label>Last Name</label>
                  <input type="text" name="last_name" value={updatedProfile.last_name || ""} onChange={handleChange} placeholder="Enter last name"/>
                </div>
                <div>
                  <label>Email</label>
                  <input type="text" name="email" value={updatedProfile.email || ""} onChange={handleChange} placeholder="Enter email-address"/>
                </div>
                <div>
                  <label>Contact No.</label>
                  <input type="text" name="phone" value={updatedProfile.phone || ""} onChange={handleChange} placeholder="Enter contact phone/mobile number"/>
                </div>
                <div>
                  <label>City</label>
                  <input type="text" name="city" value={updatedProfile.city || ""} onChange={handleChange} placeholder="Enter name of city/town"/>
                </div>
                <div>
                  <label>Province</label>
                  <input type="text" name="province" value={updatedProfile.province || ""} onChange={handleChange} placeholder="Enter province/state"/>
                </div>
                <div>
                  <label>Country</label>
                  <input type="text" name="country" value={updatedProfile.country || ""} onChange={handleChange} placeholder="Enter country"/>
                </div>
                <div>
                  <label>Zipcode</label>
                  <input type="text" name="zipcode" value={updatedProfile.zipcode || ""} onChange={handleChange} placeholder="Enter zipcode"/>
                </div>
                <div>
                  <div><label>Address</label></div>
                  <input type="text" name="address" value={updatedProfile.address || ""} onChange={handleChange} placeholder="Enter street, house no."/>
                </div>
              </form>
              
                <div className="c-modal-actions">
                  <button onClick={handleCancel} className="c-modal-button" >Cancel</button>
                  <button onClick={handleSaveprofile} type="submit" className="c-modal-button">Submit</button>
                </div>
              {error && <p style={{color: "red"}}>{error}</p>}
            </div>
          </div>
          )}
        </div> 
        :
        <div className='order-list'>
          <h2>سفارش‌های من</h2>

          <div className="order-tabs-container-fa">
            <Link to={`/${setlang}/review/open-orders`}>
              <button
                onClick={() => setActiveTab("open")}
                className={"active"}
                >
                {setlang === "en" ? "Open" : "در حال ارسال"}
              </button>
            </Link>
            <Link to={`/${setlang}/review/canceled-orders`}>
              <button
                onClick={() => setActiveTab("canceled")}
                >
                {setlang === "en" ? "Canceled" : "لغو شده"}
              </button>
            </Link>
            <Link to={`/${setlang}/review/closed-orders`}>
              <button
                onClick={() => setActiveTab("past")}
                >
                {setlang === "en" ? "Past" : "بسته شده"}
              </button>
            </Link>
          </div>

          {orders.length === 0 ? (
            <p style={{margin:'20px'}}>شما تا اکنون سفارش باز ندارید</p>
          ) : (
            orders.map((order) => (
              <>
                <div key={order.id} className='item-list'>
                  <ul>
                    {order.items.map((item) => (
                      <li key={item.id}>
                        <div className="order-images">
                          {Array.isArray(item.product_images) && item.product_images.length > 0 &&
                            item.product_images.map((img) => (
                              <img
                                key={img.id}
                                src={img.image}
                                alt={item.product_name}
                                className="order-image"
                              />
                            ))
                          }
                          {/* Videos */}
                          {Array.isArray(item.product_videos) && item.product_videos.length > 0 &&
                            item.product_videos.map((vid) => (
                              <video
                                key={vid.id} 
                                src={vid.video}
                                controls
                                className="order-image"
                              />
                            ))
                          }
                        </div>  
                        
                        <div className="arrival-note-fa">
                          <div>
                            <p><strong>{item.product_name}</strong></p>
                            <p>قیمت(تومان): {toPersiDigits(new Number(item.price).toLocaleString())}</p>
                            <p>فروشنده: {item.seller_username}</p>
                            <p>ارسال از راه: {item.shipping_style}</p>
                            <p>
                              <strong>توجه: </strong>سفارش‌های ارسالی ممکن است تا<span className="highlight"> ۱۲ روز کاری </span> به طول انجامد
                            </p>
                            {item.arrival_date === null ? null:
                              <span><strong>دریافت تا تاریخ: </strong>{toPersiDigits(dayjs.utc(item.arrival_date).calendar("jalali").locale("fa").format("YYYY/MM/DD"))}</span>
                            }
                            <div className='cont-contact-button'>
                              <button onClick={()=>handleContact(item.seller, item.product)}>{setlang === "en" ? "Contact Seller" : "تماس با فروشنده" }</button>
                            </div>

                            {isContModalOpen && (
                            <div onClick={handleOverlayClick} className="modal-overlay" type='submit'> 
                              <div className="c-modal-container" onClick={e => e.stopPropagation()}>
                                <ContactFormModal receiverId={itemSeller} itemId={itemId} setlang={setlang}/>
                              </div>
                            </div>
                            )}
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                  
                  <div className="order-sum-fa">
                    <p><strong>جمع کل(تومان): </strong>{toPersiDigits(new Number(order.total_amount).toLocaleString())}</p>
                    {order.order_status==="paid"?(
                      <p><strong>وضعیت سفارش: </strong>به زودی ارسال خواهد شد </p>
                    ):(
                      <p>وضعیت: {order.order_status}</p>
                    )}
                    <p>شماره سفارش: {order.order_number}</p>
                    <p>تاریخ سفارش: {toPersiDigits(dayjs.utc(order.created_at).calendar("jalali").locale("fa").format("YYYY/MM/DD"))}</p>
                  </div>

                  <div className='delivery-info-fa'>
                    <h3>آدرس پستی</h3>
                    <p>شماره رهگیری پست: {order.delivery.tracking_number} </p>
                    <p>وضعیت سفارش: {order.delivery.status}</p>
                    <p>گیرنده: {order.delivery.first_name}, {order.delivery.last_name}</p>
                    <p>ایمیل: {order.delivery.email}</p>
                    <p>موبایل: {order.delivery.contact}</p>
                    <p>{order.delivery.address} </p>
                    <p>{order.delivery.city}, {order.delivery.province}, {order.delivery.country} </p>
                    <p>کد پستی: {order.delivery.zipcode}</p>
                  </div>
                  <div className="order-actions">
                    <button className='btn-remove' onClick={() => handleCancelOrder(order.id)}>لغو سفارش</button>
                    <button className='btn' onClick={() => openModal(order.id)}>به روزرسانی آدرس پستی</button>
                  </div>
                </div>
              </>
            ))
          )}
          {isModalOpen && (
          <div onClick={handleOverlayClick} className="modal-overlay" type='submit'> 
            <div className="c-modal-container" onClick={e => e.stopPropagation()}>
              <h1>آدرس پستی</h1>
              <p>لطفا از درستی آدرس پستی خود اطمینان حاصل فرمایید</p>
              <form>
                <div>
                  <label>نام خانوادگی</label>
                  <input type="text" name="last_name" value={updatedProfile.last_name || ""} onChange={handleChange} placeholder="نام خانوادگی گیرنده"/>
                </div>
                <div>
                  <label>نام</label>
                  <input type="text" name="first_name" value={updatedProfile.first_name || ""} onChange={handleChange} placeholder="نام گیرنده" />
                </div>
                <div>
                  <label>ایمیل</label>
                  <input type="text" name="email" value={updatedProfile.email || ""} onChange={handleChange} placeholder="ایمیل"/>
                </div>
                <div>
                  <label>موبایل</label>
                  <input type="text" name="phone" value={updatedProfile.phone || ""} onChange={handleChange} placeholder="شماره تماس"/>
                </div>
                <div>
                  <label>استان</label>
                  <input type="text" name="province" value={updatedProfile.province || ""} onChange={handleChange} placeholder="استان"/>
                </div>
                <div>
                  <label>شهر</label>
                  <input type="text" name="city" value={updatedProfile.city || ""} onChange={handleChange} placeholder="نام شهر یا منطقه"/>
                </div>
                <div>
                  <label>کشور</label>
                  <input type="text" name="country" value={updatedProfile.country || ""} onChange={handleChange} placeholder="کشور"/>
                </div>
                <div>
                  <label>کد پستی</label>
                  <input type="text" name="zipcode" value={updatedProfile.zipcode || ""} onChange={handleChange} placeholder="کد پستی گیرنده"/>
                </div>
                <div>
                  <div><label>آدرس پستی</label></div>
                  <input type="text" name="address" value={updatedProfile.address || ""} onChange={handleChange} placeholder="آدرس پستی خود را وارد کنید"/>
                </div>
              </form>
              <div className="c-modal-actions">
                <button onClick={handleCancel} className="c-modal-button" >لغو</button>
                <button onClick={handleSaveprofile} type="submit" className="c-modal-button">ذخیره</button>
              </div>
              {error && <p style={{color: "red"}}>{error}</p>}
            </div>
          </div>
          )}
        </div>
        }
        {setlang==="fa" && 
          <Sidebar />
        }
      </div>
      </SidebarProvider>
      <Footer />
    </>
  );
};

export default OrderReview;
